import { withDevTools } from '../../utils/with-dev-tools';
import { wrapServiceWithResult } from '../../utils/wrap-service-with-result';
import { followMember as serverFollowMember, unfollowMember as serverUnfollowMember, } from '@wix/ambassador-members-v3-follow/http';
export function createMembersService({ httpClient, getDevState, onError, }) {
    const service = (() => {
        const api = {
            followMember: followMember(httpClient),
            unfollowMember: unfollowMember(httpClient),
        };
        return withDevTools(api, getDevState);
    })();
    return wrapServiceWithResult(service, {
        errorEffect: onError,
    });
}
const followMember = (httpClient) => async (payload) => {
    await httpClient.request(serverFollowMember(payload));
};
const unfollowMember = (httpClient) => async (payload) => {
    await httpClient.request(serverUnfollowMember(payload));
};
//# sourceMappingURL=create-members-service.js.map